if (!customElements.get("m-product-details-tabs")) {
  class MProductDetailsTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = new MinimogTheme.Tabs(this);

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const tabHeader = event && event.target;
          const index = (tabHeader && Number(tabHeader.dataset.index)) || 0;
          this.tabs && this.tabs.setActiveTab(index);
        });
      }
    }
  }
  customElements.define("m-product-details-tabs", MProductDetailsTabs);
}

window.addEventListener("load", function(){
  let tabContents = document.querySelectorAll(".m-product-details-tabs .m-tabs__content .m-tab-content")

  for(let i = 0; i < tabContents.length; i++){
    for(let j = 0; j < tabContents[i].childNodes.length; j++){
      if(tabContents[i].childNodes[j].className == 'm-tab-content__inner'){
        for(let k = 0; k < tabContents[i].childNodes[j].childNodes.length; k++){
          if(tabContents[i].childNodes[j].childNodes[k].className == 'rte' || tabContents[i].childNodes[j].childNodes[k].className == 'container'){
            if(tabContents[i].childNodes[j].childNodes[k].innerHTML.replace(/\s|\\n?/g, '') == ''){
              let tabsToHide = (document.querySelectorAll(".m-product-details-tabs .m-tabs__header .m-tab-header[data-index='" + i + "']"))

              for(let l = 0; l < tabsToHide.length; l++){
                tabsToHide[l].style.display = 'none'
              }
            }
          }
        }
      }
    }
  }

  let viProductRating = document.getElementsByClassName('jdgm-preview-badge--with-link')
  let viRatingProductTab = document.querySelectorAll(".m-tab-header[data-block-type='reviews']")

  if(viProductRating.length > 0 && viRatingProductTab.length > 0){
    viProductRating[0].addEventListener('click', function (event) {
      viRatingProductTab[0].click()
    })
  }
});
